import React from 'react';
import { findDocumentType } from '../utils/documentTypes'
import { Label, Icon, Modal, Popup } from 'semantic-ui-react'
import DocumentAttributes from './DocumentAttributes'
import DocumentPreview from './DocumentPreview'

class DocumentLabels extends React.Component {
  constructor (){
    super()
    this.state = {}
  }

  handleOpenPreview(document){
    this.setState({ isModalOpened: true, shownDocument: document })
  }
  handleClosePreview(){
    this.setState({ isModalOpened: false })
  }

  render(){
    const { documents, onDeleteClick, previewOnly } = this.props

    const labels = (documents || []).map((document, i) => {
      const documentType = findDocumentType(document.type)
      if (!documentType.value) return null
      return (
        <Label
          target="_blank"
          style={{ 'padding': '2px', 'display':'inline-flex', 'margin':'2px'}}
          color={documentType.color}
          key={i}>
          <div
            onClick={this.handleOpenPreview.bind(this, document)}
            style={{cursor:'pointer', 'margin':'5px 3px'}}
          > {documentType.text} </div>
          <div>
        { document.formAttributes &&
          <Popup trigger={
            <Icon
            name="info circle"
            style={{cursor:'pointer', 'margin': '3px'}}
            size="large" />
          }
          on="click"
          position="top center"
          >
          <DocumentAttributes data={JSON.parse(document.formAttributes)}  />
          </Popup>
        }
        {!previewOnly &&
          <Icon
          onClick={onDeleteClick.bind(this, document.id)}
          name="delete"
          style={{cursor:'pointer', 'margin': '3px'}}
          size="large"
          />
        }
          </div>
        </Label>
      )
    })
    return (
      <React.Fragment>
        <Modal
          open={this.state.isModalOpened}
          dimmer={true}
          basic
          closeIcon
          onClose={this.handleClosePreview.bind(this)}>
          <Modal.Content
            onClick={this.state.shownDocument && (this.state.shownDocument.attachmentContentType === 'application/pdf')
            ? null
            : this.handleClosePreview.bind(this)}>
            <DocumentPreview document={this.state.shownDocument} />
          </Modal.Content>
        </Modal>
        { labels }
      </React.Fragment>
    )
  }
}
export default DocumentLabels;



// WEBPACK FOOTER //
// ./src/component/DocumentLabels.js